import { createAction } from '@reduxjs/toolkit'
import { ResponseAdmin } from '@ads/front-core/api'
import { TDictionary } from '@ads/front-core/interfaces'
import { RootState } from '@ads/front-core/store/rootState'

type SetAdmins = {
  role: ResponseAdmin['role']
  list: TDictionary[]
}

export const setAdmins = createAction<SetAdmins>('admin/setAdmins')

export const setAdminsReducer = (
  state: RootState['admins'],
  action: ReturnType<typeof setAdmins>,
): void => {
  const { role, list } = action.payload
  state[role] = list
}
